module.exports = __webpack_public_path__ + "static/img/customer-background.871eebd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/astrology/customer-background.png
// module id = uy8K
// module chunks = 0